import type { PassportCommand } from "@peer-start/platform-contracts";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  fetchPassportBootstrap,
  fetchPassportPage,
  fetchStampDetail,
  sendPassportCommand,
} from "./client.js";

export const passportBootstrapQueryKey = ["passport-bootstrap"] as const;
const pageKey = (employeeId: string, pageId: string) => ["passport-page", employeeId, pageId] as const;
const stampKey = (employeeId: string, stampId: string) => ["passport-stamp", employeeId, stampId] as const;

export function usePassportBootstrap(enabled = true) {
  return useQuery({ queryKey: passportBootstrapQueryKey, queryFn: fetchPassportBootstrap, enabled });
}

export function usePassportPage(employeeId: string, pageId: string) {
  return useQuery({
    queryKey: pageKey(employeeId, pageId),
    queryFn: () => fetchPassportPage(employeeId, pageId),
    enabled: Boolean(employeeId && pageId),
  });
}

export function useStampDetail(employeeId: string, stampId: string) {
  return useQuery({
    queryKey: stampKey(employeeId, stampId),
    queryFn: () => fetchStampDetail(employeeId, stampId),
    enabled: Boolean(employeeId && stampId),
  });
}

export function usePassportCommand() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (command: PassportCommand) => sendPassportCommand(command),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: passportBootstrapQueryKey });
      await queryClient.invalidateQueries({ queryKey: ["passport-page"] });
      await queryClient.invalidateQueries({ queryKey: ["passport-stamp"] });
    },
  });
}
